import { types, MoneyType } from "../types";
import has from "lodash/has";

export interface IMoneyState {
  size: number;
  level: number;
  levels: number[];
  denomination: number;
  denominations: number[];
  betInCoins: number;
  betInCash: number;
  balanceInCash: number;
  balanceInCoins: number;
  winInCoins: number;
  winInCash: number;
  winDenomination: number;
  winTotalInCoins: number;
  winTotalInCash: number;
  winTotalDenomination: number;
  currencyFormat: ICurrencyFormat;
  moneyTypes: MoneyType[];
  moneyType: MoneyType;
}

export interface ICurrencyFormat {
  iso: string;
  symbol?: string;
  decimals: number;
  decimalDivider: string;
  thousandsDivider: string;
  coinsDivider?: string;
  showCurrencyChar: boolean;
}

export const defaultState: IMoneyState = {
  size: null,
  level: null,
  levels: [],
  denomination: null,
  denominations: [],
  betInCoins: null,
  betInCash: null,
  balanceInCash: null,
  balanceInCoins: null,
  winInCoins: null,
  winInCash: null,
  winDenomination: null,
  winTotalInCoins: null,
  winTotalInCash: null,
  winTotalDenomination: null,
  moneyTypes: [MoneyType.CASH, MoneyType.COINS],
  moneyType: MoneyType.CASH,
  currencyFormat: {
    decimals: 2,
    decimalDivider: ",",
    thousandsDivider: ".",
    coinsDivider: " ",
    symbol: "",
    iso: "",
    showCurrencyChar: true
  }
};

export const bet = (state = defaultState, action) => {
  if (action.type === types.SET_STATE && has(action.value, "bet")) {
    const { bet } = action.value;

    return {
      betInCash: bet.valueInCash ?? state.betInCash,
      betInCoins: bet.valueInCoins ?? state.betInCoins,
      denomination: bet.denomination ?? state.denomination,
      denominations: bet.denominations ?? state.denominations,
      level: bet.level ?? state.level,
      levels: bet.levels ?? state.levels,
      size: bet.size ?? state.size
    };
  }
};

export const balance = action => {
  if (action.type === types.SET_STATE && has(action.value, "balance")) {
    const { balance } = action.value;

    return {
      balanceInCash: balance.valueInCash,
      balanceInCoins: balance.valueInCoins
    };
  }
};

export const currency = (state = defaultState, action) => {
  if (action.type === types.SET_STATE && has(action.value, "currency")) {
    const { currency } = action.value;

    return {
      currencyFormat: { ...state.currencyFormat, ...currency }
    };
  }
};

export const totalWin = action => {
  if (action.type === types.SET_STATE && has(action.value, "totalWin")) {
    const { totalWin } = action.value;
    return {
      winTotalDenomination: totalWin.denomination,
      winTotalInCash: totalWin.valueInCash,
      winTotalInCoins: totalWin.valueInCoins
    };
  }
};

export const moneyType = action => {
  if (action.type === types.SET_STATE && has(action.value, "moneyType")) {
    const { moneyType } = action.value;
    return {
      moneyType
    };
  }
};

export const moneyTypes = action => {
  if (action.type === types.SET_STATE && has(action.value, "moneyTypes")) {
    const { moneyTypes } = action.value;
    return {
      moneyTypes
    };
  }
};

export const win = action => {
  if (action.type === types.SET_STATE && has(action.value, "win")) {
    const { win } = action.value;
    return {
      winDenomination: win.denomination,
      winInCash: win.valueInCash,
      winInCoins: win.valueInCoins
    };
  }
};

export const money = (state = defaultState, action) => {
  const betState = bet(state, action);
  const balanceState = balance(action);
  const winState = win(action);
  const totalWinState = totalWin(action);
  const currencyState = currency(state, action);
  const moneyTypeState = moneyType(action);
  const moneyTypesState = moneyTypes(action);

  return {
    ...state,
    ...betState,
    ...balanceState,
    ...winState,
    ...totalWinState,
    ...currencyState,
    ...moneyTypeState,
    ...moneyTypesState
  };
};
